<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Devoluciones de Traslados</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="C">Finalizado</option>
                  <option value="D">En Contenedor</option>
                  <option value="E">En Ruta</option>
                  <option value="F">Entregado</option>
                  <option value="G">Recepcionando</option>
                  <option value="H">Detallado</option>
                </select>
              </div>
            </div>
          </div>

          <TarimaDevolucionTableComponent :tarima="tarimas" />
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="tarimas"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import TarimaDevolucionTableComponent from "@/components/inventario/tarimas_devoluciones/TarimaDevolucionTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    TarimaDevolucionTableComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      tarimas: "",
    };
  },
  mounted() {
    let self = this;
    self.refreshTarimas();
  },
  methods: {
    refreshTarimas() {
      let self = this;
      DynamicService.fetch("wms", "tarima", {
        devolucion: true,
      }).then((response) => {
        self.tarimas = response.data;
      });
    },
    filterData() {
      this.$data.currentPage = 1;
      DynamicService.fetch("wms", "tarima", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
      })
        .then((response) => {
          this.tarimas = response.data;
        })
        .catch((error) => {
          this.data = "";
        });
    },
    clearFilterData() {
      this.filtro_estado = "";
      this.searchtext = "";
      this.$data.currentPage = 1;
      this.filterData();
    },
    onPageChange(page) {
      let self = this;
      this.currentPage = page;
      DynamicService.fetch("wms", "tarima", {
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
      }).then((response) => {
        self.tarimas = response.data;
      });
    },
  },
};
</script>
